import axios from 'axios'
// import { useAppStore } from "@/stores/appStore";

const apiAxios = axios.create({
  baseURL:
    location.hostname === 'localhost'
      ? 'http://localhost:5000/api'
      : process.env.VUE_APP_ROOT_API
})

// 內部網域 API（註冊率統計等）
const internalApiAxios = axios.create({
  baseURL: process.env.VUE_APP_INTERNAL_API
})

class ApiError extends Error {
  constructor(message) {
    super(message)
    this.name = 'ApiError'
  }
}

// apiAxios.interceptors.request.use((config) => {
//   const store = useAppStore();

//   if (config.data instanceof FormData) {
//     config.headers["Content-Type"] = "multipart/form-data";
//   } else {
//     config.headers["Content-Type"] = "application/json";
//   }

//   let accessToken = store.accessToken;

//   if (accessToken) {
//     config.headers.Authorization = `Bearer ${accessToken}`;
//   }

//   return config;
// });

// apiAxios.interceptors.response.use(
//   (response) => {
//     if (response.data.status != 1) {
//       return Promise.reject(new ApiError(response.data.result.result_message));
//     } else {
//       return response.data;
//     }
//   },
//   ({ response }) => {
//     if (response) {
//       if (response.status === 401) {
//         return Promise.reject(new ApiError("未授權"));
//       } else if (response.status === 403) {
//         return Promise.reject(new ApiError("權限不足"));
//       } else if (response.status === 404) {
//         return Promise.reject(new ApiError("錯誤路徑"));
//       } else if (response.status === 422) {
//         return Promise.reject(new ApiError(response.data.message));
//       } else if (response.status >= 500 && response.status < 600) {
//         return Promise.reject(new ApiError("發生不可預期錯誤"));
//       } else {
//         return Promise.reject(response.data);
//       }
//     } else {
//       if (!window.navigator.onLine) {
//         return Promise.reject(new ApiError("無網路連線"));
//       } else {
//         return Promise.reject(new ApiError("資料存取錯誤"));
//       }
//     }
//   }
// );

export { apiAxios, internalApiAxios, ApiError }
